
import {
  dealjacketConstants,
  alertConstants,
  userConstants,
} from "../constants";
import { dealjacketService } from "../services";
import { alertActions } from "./alert.actions.js";

export const dealjacketActions = {
  getList,
  getDetail,
  uploadJacket,
  uploadDocument,
  search,
  searchRequestViolation,
  editJacketName,
  getDealNumberMatches,
  clearSearch,
  editDealJacket
};

function clearSearch() {
  return { type: dealjacketConstants.DEALJACKET_CLEAR_SEARCH };
}

function getList(org_id) {
  return (dispatch) => {
    dispatch(fetchAlert("fetching dealjackets..."));
    dispatch(listRequest(org_id));

    dealjacketService.getList(org_id).then(
      (list) => {
        dispatch(refreshToken(list.newToken));
        dispatch(clearAlert());
        dispatch(success(list));
      },
      (error) => {
        dispatch(clearAlert());
        dispatch(failure(error));
        /*dispatch(alertActions.error('unable to reach remote server.'));*/
      }
    );
  };
  function fetchAlert(message) {
    return { type: alertConstants.SPINNER, message };
  }
  function listRequest(org_id) {
    return { type: dealjacketConstants.DEALJACKET_LIST_REQUEST, org_id };
  }
  function refreshToken(token) {
    return { type: userConstants.TOKEN_REFRESH, token };
  }
  function clearAlert() {
    return { type: alertConstants.CLEAR };
  }
  function success(list) {
    return { type: dealjacketConstants.DEALJACKET_LIST_SUCCESS, list };
  }
  function failure(message) {
    return { type: dealjacketConstants.DEALJACKET_LIST_FAILURE, message };
  }
}

function searchRequestViolation(display) {
  if (display) {
    return { type: "search_request_violation" }
  }
  return { type: "clear_search_request_violation" }
}

function getDealNumberMatches(org_id, deal_number_entry) {
  return (dispatch) => {
    dispatch(fetchAlert("fetching matches..."));
    dispatch(listRequest(org_id, deal_number_entry));

    dealjacketService.getDealNumberMatches(org_id, deal_number_entry).then(
      (list) => {
        dispatch(refreshToken(list.newToken));
        dispatch(clearAlert());
        dispatch(success(list));
      },
      (error) => {
        dispatch(clearAlert());
        dispatch(failure(error));
        /*dispatch(alertActions.error('unable to reach remote server.'));*/
      }
    );
  };

 function fetchAlert(message) {
    return { type: alertConstants.SPINNER, message };
  }
  function listRequest(org_id) {
    return {
      type: dealjacketConstants.DEALJACKET_CHECK_DEAL_NUMBER_REQUEST,
      org_id, deal_number_entry
    };
  }
  function refreshToken(token) {
    return { type: userConstants.TOKEN_REFRESH, token };
  }
  function clearAlert() {
    return { type: alertConstants.CLEAR };
  }
  function success(list) {
    return { type: dealjacketConstants.DEALJACKET_CHECK_DEAL_NUMBER_SUCCESS, list };
  }
  function failure(message) {
    return {
      type: dealjacketConstants.DEALJACKET_CHECK_DEAL_NUMBER_FAILURE,
      message: dealjacketConstants.DEALJACKET_CHECK_DEAL_NUMBER_FAILURE,
    };
  }
};

function getDetail(dealjacket_id) {
  return (dispatch) => {
    dispatch(fetchAlert("fetching pages..."));
    dispatch(detailRequest(dealjacket_id));

    dealjacketService.getDetail(dealjacket_id).then(
      (pages) => {
        dispatch(refreshToken(pages.newToken));
        dispatch(clearAlert());
        dispatch(success(pages));
      },
      (error) => {
        dispatch(clearAlert());
        dispatch(failure(error));
        /*dispatch(alertActions.error('unable to reach remote server.'));*/
      }
    );
  };

  function fetchAlert(message) {
    return { type: alertConstants.SPINNER, message };
  }
  function detailRequest(dealjacket_id) {
    return {
      type: dealjacketConstants.DEALJACKET_DETAIL_REQUEST,
      dealjacket_id,
    };
  }
  function refreshToken(token) {
    return { type: userConstants.TOKEN_REFRESH, token };
  }
  function clearAlert() {
    return { type: alertConstants.CLEAR };
  }
  function success(pages) {
    return { type: dealjacketConstants.DEALJACKET_DETAIL_SUCCESS, pages };
  }
  function failure(message) {
    return { type: dealjacketConstants.DEALJACKET_DETAIL_FAILURE, message };
  }
}

function uploadJacket(file) {
  return (dispatch) => {
    dispatch(uploadAlert("uploading..."));
    dispatch(uploadRequest(file));

    dealjacketService.uploadFile(file).then(
      (response) => {
        dispatch(refreshToken(response.newToken));
        dispatch(clearAlert());
        dispatch(success(file));
      },
      (error) => {
        dispatch(clearAlert());
        dispatch(failure(file));
        dispatch(alertActions.error("There was a problem uploading the file."));
      }
    );
  };

  function uploadAlert(message) {
    return { type: alertConstants.SPINNER, message };
  }
  function uploadRequest(file) {
    return { type: dealjacketConstants.DEALJACKET_UPLOAD_REQUEST, file };
  }
  function refreshToken(token) {
    return { type: userConstants.TOKEN_REFRESH, token };
  }
  function clearAlert() {
    return { type: alertConstants.CLEAR };
  }
  function success(file) {
    return { type: dealjacketConstants.DEALJACKET_UPLOAD_SUCCESS, file };
  }
  function failure(file) {
    return { type: dealjacketConstants.DEALJACKET_UPLOAD_FAILURE, file };
  }
}

function uploadDocument(uploadObject) {
  return (dispatch) => {
    dispatch(uploadAlert("uploading..."));
    dispatch(uploadRequest(uploadObject));

    dealjacketService.uploadDocument(uploadObject).then(
      (response) => {
        dispatch(refreshToken(response.newToken));
        dispatch(successAlert("Upload successful. Your file is being processed, and will be searchable within a few minutes."));
        dispatch(success(uploadObject));
      },
      (error) => {
        dispatch(clearAlert());
        dispatch(failure(uploadObject));
        dispatch(alertActions.error(error));
      }
    );
  };

  function uploadAlert(message) {
    return { type: alertConstants.SPINNER, message };
  }
  function uploadRequest(uploadObject) {
    return { type: dealjacketConstants.DEALJACKET_UPLOAD_REQUEST, uploadObject };
  }
  function refreshToken(token) {
    return { type: userConstants.TOKEN_REFRESH, token };
  }
  function clearAlert() {
    return { type: alertConstants.CLEAR };
  }
  function successAlert(message) {
    return { type: alertConstants.SUCCESS, message};
  }
  function success(uploadObject) {
    return { type: dealjacketConstants.DEALJACKET_UPLOAD_SUCCESS, uploadObject };
  }
  function failure(uploadObject) {
    return { type: dealjacketConstants.DEALJACKET_UPLOAD_FAILURE, uploadObject };
  }
}

function search(searchRequest) {
  return (dispatch) => {
    dispatch(searchAlert("searching dealjackets..."));
    dispatch(request(searchRequest));

    dealjacketService.search(searchRequest).then(
      (list) => {
        dispatch(refreshToken(list.newToken));
        dispatch(clearAlert());
        dispatch(success(list));
      },
      (error) => {
        dispatch(clearAlert());
        dispatch(failure(error));
        /*dispatch(alertActions.error('unable to reach remote server.'));*/
      }
    );
  };

  function searchAlert(message) {
    return { type: alertConstants.SPINNER, message };
  }
  function request(searchRequest) {
    return { type: dealjacketConstants.SEARCH_REQUEST, searchRequest };
  }
  function refreshToken(token) {
    return { type: userConstants.TOKEN_REFRESH, token };
  }
  function clearAlert() {
    return { type: alertConstants.CLEAR };
  }
  function success(list) {
    return { type: dealjacketConstants.SEARCH_SUCCESS, list };
  }
  function failure(message) {
    return { type: dealjacketConstants.SEARCH_FAILURE, message };
  }
}

function editJacketName(jacket) {
  return (dispatch) => {
    dispatch(uploadAlert("editing..."));
    dispatch(editRequest(jacket));

    dealjacketService.editJacketName(jacket).then(
      (response) => {
        dispatch(refreshToken(response.newToken));
        dispatch(clearAlert());
        dispatch(success(response));
      },
      (error) => {
        dispatch(clearAlert());
        dispatch(failure(jacket));
        dispatch(alertActions.error("There was a problem uploading the file."));
      }
    );
  };

  function uploadAlert(message) {
    return { type: alertConstants.SPINNER, message };
  }
  function editRequest(jacket) {
    return { type: dealjacketConstants.DEALJACKET_EDIT_NAME_REQUEST, jacket };
  }
  function refreshToken(token) {
    return { type: userConstants.TOKEN_REFRESH, token };
  }
  function clearAlert() {
    return { type: alertConstants.CLEAR };
  }
  function success(jacket) {
    return { type: dealjacketConstants.DEALJACKET_EDIT_NAME_SUCCESS, jacket };
  }
  function failure(jacket) {
    return { type: dealjacketConstants.DEALJACKET_EDIT_NAME_FAILURE, jacket };
  }
}

function editDealJacket(jacket) {
  return (dispatch) => {
    dispatch(uploadAlert("editing..."));
    dispatch(editRequest(jacket));

    dealjacketService.editDealJacket(jacket).then(
      (response) => {
        dispatch(refreshToken(response.newToken));
        dispatch(clearAlert());
        dispatch(success(response));
      },
      (error) => {
        dispatch(clearAlert());
        dispatch(failure(jacket));
        dispatch(alertActions.error("There was a problem updating the deal jacket."));
      }
    );
  };

  function uploadAlert(message) {
    return { type: alertConstants.SPINNER, message };
  }
  function editRequest(jacket) {
    return { type: dealjacketConstants.DEALJACKET_EDIT_REQUEST, jacket };
  }
  function refreshToken(token) {
    return { type: userConstants.TOKEN_REFRESH, token };
  }
  function clearAlert() {
    return { type: alertConstants.CLEAR };
  }
  function success(jacket) {
    return { type: dealjacketConstants.DEALJACKET_EDIT_SUCCESS, jacket };
  }
  function failure(jacket) {
    return { type: dealjacketConstants.DEALJACKET_EDIT_FAILURE, jacket };
  }
}
